export const SUBSCRIPTION_CHART_COLORS = [
  "#1E61DC",
  "#60A5FA",
  "#93C5FD",
  "#BFDBFE",
];

export const getRevenueByPlan = (subscriptionReportsData) =>
  Object.entries(subscriptionReportsData?.data?.mrrBySubscriptionPlan || {}).map(
    ([planName, planData]) => ({
      name:
        planName.charAt(0).toUpperCase() +
        planName.slice(1).replace(/([A-Z])/g, " $1"),
      value: planData?.monthlyRevenue || 0,
      percentage: planData?.percentage || 0,
    }),
  );

export const getPlanDistribution = (subscriptionReportsData) =>
  Object.entries(subscriptionReportsData?.data?.planDistributionVolume || {}).map(
    ([plan, subscribers]) => ({
      plan,
      subscribers,
    }),
  );
